/*
 * Copyright (c) 2024 Amazon.com, Inc. All Rights Reserved.
 */

/**
 * @author stcatai Mar 22, 2024
 */
export enum Region {
  NA = "NA",
  EU = "EU",
  FE = "FE",
  CN = "CN"
}